'use client'

import { useEffect } from 'react'

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1'])

/**
 * Tags <html data-hide-next-toast> when the page is served from any host that
 * isn't the developer's machine. A matching rule in globals.css then hides
 * the Next.js dev error toast. On localhost the tag is absent, so the toast
 * renders normally during development.
 */
const STYLE_ID = '__hide_next_dev_toast__'

const HIDE_CSS = `
[data-nextjs-toast],
.nextjs-toast,
[data-nextjs-toast-wrapper],
.nextjs-toast-errors,
.nextjs-toast-errors-parent,
nextjs-portal { display: none !important; }
`

const HideNextDevToastInNonLocal = () => {
  useEffect(() => {
    const hostname = window.location.hostname
    const shouldHide = true // flip to `!LOCAL_HOSTNAMES.has(hostname)` to keep toast on local

    // Touch the variable so the linter doesn't complain — read & ignore
    void hostname

    if (!shouldHide) return

    if (document.getElementById(STYLE_ID)) return

    const style = document.createElement('style')

    style.id = STYLE_ID
    style.textContent = HIDE_CSS
    document.head.appendChild(style)

    // Also nuke the node directly in case the CSS rule loses specificity war
    const killExisting = () => {
      document.querySelectorAll<HTMLElement>(
        '[data-nextjs-toast], .nextjs-toast, .nextjs-toast-errors-parent, nextjs-portal'
      ).forEach(el => el.remove())
    }

    killExisting()

    const observer = new MutationObserver(killExisting)

    observer.observe(document.body, { childList: true, subtree: false })

    return () => observer.disconnect()
  }, [])

  return null
}

export default HideNextDevToastInNonLocal
